import { LeftOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Spin, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";

const { Text } = Typography;

const capitalizeWords = (value) =>
  typeof value === "string"
    ? value.replace(
        /\w\S*/g,
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
    : value;

const detailColumns = [
  {
    dataIndex: "description",
    key: "description",
    width: "45%",
    onCell: () => ({
      style: {
        backgroundColor: "#F5F5F5",
      },
    }),
    render: (text) => (
      <Text strong style={{ color: "#000000" }}>
        {text}
      </Text>
    ),
  },
  {
    dataIndex: "item",
    key: "item",
    width: "55%",
    render: (value) => value ?? "-",
  },
];

function DetailChequeBook(props) {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log("Savings account:", state);
  const [isLoading, setIsLoading] = useState(true);
  const [leaveDetails, setLeaveDetails] = useState({});

  useEffect(() => {
    if (state?.id === undefined || state?.id === null) {
      BOM.AlertMsg(cnt.DANGER, "Cheque Book Request id is required");
    }

    getChequeLeave();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getChequeLeave = () => {
    const url = `${apiConfig.Cheques}/chequeleaves/${state?.leaf?.id}`;
    const body = { session };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(
          cnt.DANGER,
          err?.defaultUserMessage || "Failed to fetch cheque leaves",
        );
      } else {
        setLeaveDetails({
          key: res?.id,
          id: res?.id,
          chequeBookNo: res?.chequeBookNo || "-",
          accountNo: res?.accountNo || "-",
          chequeDate: res?.chequeDate || "-",
          chequeNo: res?.chequeNo || "-",
          chequeStatus: res?.status === "U" ? "Used" : "Not used",
          transactionDate: res?.transactionDate || "-",
          amount: BOM.FormatAmount(res?.amount) || "-",
          narration: res?.narration || "-",
        });

        setIsLoading(false);
      }
    });
  };

  const leftDetailData = [
    {
      key: "accountNo",
      description: "Account No",
      item: leaveDetails?.accountNo,
    },
    {
      key: "chequeNo",
      description: "Cheque No",
      item: leaveDetails?.chequeNo,
    },
    {
      key: "transactionDate",
      description: "Transaction Date",
      item: leaveDetails?.transactionDate,
    },
    {
      key: "chequeStatus",
      description: "Cheque Status",
      item: leaveDetails?.chequeStatus,
    },
  ];

  const rightDetailData = [
    {
      key: "chequeBookNo",
      description: "Cheque Book No",
      item: leaveDetails?.chequeBookNo,
    },
    {
      key: "chequeDate",
      description: "Cheque Date",
      item: leaveDetails?.chequeDate,
    },
    {
      key: "narration",
      description: "Narration",
      item: capitalizeWords(leaveDetails?.narration),
    },
    {
      key: "amount",
      description: "Amount",
      item: BOM.FormatAmount(leaveDetails?.amount),
    },
  ];

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.detailChequeBookRequest}
        pageItems={staticConfig.detailChequeBookRequestBreadcrumbItems(state)}
      />
      <Spin spinning={isLoading} size="large">
        <>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={
              <Row
                justify="space-between"
                style={{ alignContent: "center", width: "100%" }}
              >
                <Button
                  icon={<LeftOutlined />}
                  type="text"
                  style={{ marginTop: "auto", marginBottom: "auto" }}
                  onClick={() =>
                    navigate("/view-cheque-book-request", { state })
                  }
                >
                  <Text
                    style={{
                      marginTop: "auto",
                      marginBottom: "auto",
                      fontSize: 15,
                    }}
                  >
                    Back
                  </Text>
                </Button>
              </Row>
            }
          >
            <Row gutter={24}>
              <Col span={12}>
                <Table
                  columns={detailColumns}
                  dataSource={leftDetailData}
                  pagination={false}
                  showHeader={false}
                  bordered
                />
              </Col>

              <Col span={12}>
                <Table
                  columns={detailColumns}
                  dataSource={rightDetailData}
                  pagination={false}
                  showHeader={false}
                  bordered
                />
              </Col>
            </Row>
          </Card>
        </>
      </Spin>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(DetailChequeBook);
